'use client'
import React from 'react'
import FilterContentSection from '../../sections/filterContentList'
import BreadCrumbs from '../../sections/breadcrumbs'
import { buildLocalHost } from '@/core/utils/buildHost'

const LocationsPage = ({
  intro_text,
  body,
  breadcrumbs,
  cta,
  perPage = 6,
  get_filters,
  quick_filters,
  get_global_attributes,
  get_additional_filters,
  host,
  contact,
}) => {
  const { title, text } =
    (intro_text && intro_text[0] && intro_text[0].value) || {}
  const extraContent = body && body[0] && body[0].value
  const ctaData = cta?.length > 0 && {
    title: cta[0].value?.link?.text,
    href: cta[0].value?.link?.href || cta[0].value?.link?.external_url,
    img: cta[0].value?.image,
  }
  const quickFilters =
    (quick_filters && quick_filters[0] && quick_filters[0].value) || {}
  const hostToUse = host ? host : buildLocalHost()

  return (
    <>
      <BreadCrumbs breadcrumbs={breadcrumbs} spacing={60} />

      <FilterContentSection
        filterSubList={quickFilters}
        mainFilters={get_filters}
        attributeFilters={get_global_attributes}
        additionalFilters={get_additional_filters}
        title={title}
        text={text}
        extraContent={extraContent}
        ctaPosition={3}
        perPage={perPage}
        cta={ctaData}
        ctaVariant="colored"
        host={hostToUse}
        isLocation={true}
      />
    </>
  )
}

export default LocationsPage
